import { InOrderState } from "src/models/InOrder";

export function translateInOrderStatus(status: string): string {
  switch (status) {
    case InOrderState.CREATED:
      return 'Criada';
    case InOrderState.RECEIVING:
      return 'Em Recebimento';
    case InOrderState.FINISHED:
      return 'Finalizada';
    default:
      return status;
  }
}

export function translateInOrderEntrySource(entrySource: string): string {
  switch (entrySource) {
    case 'MANUAL':
      return 'Interna';
    case 'INVOICE_XML':
      return 'Nota Fiscal';
    default:
      return entrySource;
  }
}